<template>
<div id="notification-settings" ref="notification"
	class="grid-2"
>
	<h3>Notification Settings</h3>
	<!--<div class="span-2">
		<label for="notifyPm-setting"><input id="notifyPm-setting" type="checkbox" class="setting" style="width:12px;" autocomplete="off">
			Enable Chrome/Safari browser notifications.</label>
		<p>When you receive a PM while an RPH window isn't focused, this will make a desktop notification. (I don't think this works anymore)</p>
	</div>-->
	<div>
		<label for="imVolume-setting" style="display:block;">
			<span style="width:50%; display:inline-block;">Private Message Volume <span class="display-val percentage">&nbsp;</span>%</span>
			<div class="slider" style="width:50%;" />
			<input id="imVolume-setting" type="text" class="setting" style="display:none;">
		</label>
		<p>Adjusts volume for when you receive a new private message.</p>
	</div>
	<div>
		<label for="pingVolume-setting" style="display:block;"><span style="width:50%; display:inline-block;">Room Ping Volume <span class="display-val percentage" />%</span><div class="slider" style="width:50%;" /><input id="pingVolume-setting" type="text" class="setting" style="display:none;"></label>
		<p>Adjusts volume for when someone highlights your name in chat.</p>
	</div>
	<div>
		<label>
			Words to notify ping on, besides your character name(s)<input id="notifyWords-setting" type="text" class="setting">
		</label>
		<p>Comma separated.</p>
	</div>
	<div>
		<label for="notifyWordsi-setting">
			<input id="notifyWordsi-setting" type="checkbox" class="setting" style="width:12px;" autocomplete="off">
			Case sensitive notify.
		</label>
		<p>If checked, listed words and phrases will only ping if they are matched exactly.</p>
	</div>
</div>
<div id="ui-settings" ref="ui" style="display:none;"
	class="grid-2"
>
	<h3>UI Settings</h3>
	<div class="span-2">
		<label for="expand-setting">
			<input id="expand-setting" type="checkbox" class="setting" style="width:12px;" autocomplete="off">
			Expand friends-list automatically upon page load.
		</label>
	</div>
	<div class="span-2">
		<label for="sortTabs-setting">
			<input id="sortTabs-setting" type="checkbox" class="setting" style="width:12px;" autocomplete="off">
			Sort the most recently used chat tab group to the front.
		</label>
	</div>
	<div>
		<label for="msgDivider-setting">
			<input id="msgDivider-setting" type="checkbox" class="setting" style="width:12px;" autocomplete="off">
			Name-colored dividers between chat messages
		</label>
	</div>
	<div>
		<label>Maximum lines of history per room<input id="maxHistory-setting" type="text" class="setting"></label>
		<p>This may lag your PC if set too high</p>
	</div>
	<div class="span-2">
		<label for="font-setting">
			Font<br>
			<select id="font-setting" class="setting">
				<option>Andika</option><option>Dosis</option><option>Inconsolata</option><option>Open Sans</option><option>Roboto</option><option>Calibri</option><option>Ubuntu</option>
			</select>
		</label>
		<p>Changes the font for most UI elements and message text. Open Sans or Calibri are recommended. Andika may help slightly if you have dyslexia.</p>
	</div>
	<div>
		<label for="fontSize-setting">Font Size<input id="fontSize-setting" type="number" class="setting" autocomplete="off" min="0.5" step="0.0125">
		</label>
		<p>Some UI elements may not render correctly if this is too high</p>
	</div>
	<div>
		<label style="width:100%">
			<span style="width:50%; display:inline-block;">Font Weight <span class="display-val" /></span><input id="fontWeight-setting" type="text" class="setting" style="display:none;"><div class="slider" style="width:50%" max="600" step="100" min="200" />
		</label>
		<p>Base font thickness. Some elements will be +200 higher. Not all fonts support more than 2 or 3 levels of weight.</p>
	</div>
	<div>
		<label for="theme-setting">
			Theme<br>
			<select id="theme-setting" class="setting"><option>Dark</option><option>Medium</option></select>
		</label>
		<p>Changes the overall styling, primarily in regard to colors.</p>
	</div>
	<div>
		<label for="customTheme-setting">
			Custom Theme<br>
			<input id="customTheme-setting" type="text" class="setting">
		</label>
		<p>Supply a full https URL to a custom CSS stylesheet instead. This will override the base themes unless left blank</p>
	</div>
	<!--themes ーレインボーブラックホールー This theme is trash. If you like it, so are you.-->
</div>
</template>

<script>
import { watch } from 'vue'
import settings from '../js/settings.js'

export default {
	components: {

	},
	data: () => ({
		settings
	}),
	mounted(){
		const $wrappers = $( [this.$refs.notification, this.$refs.ui] )
		// console.log('this el...', this.$refs.notification, this.$refs.ui)

		$wrappers.find( '.slider' ).each( function(){
			const $this = $( this )
			$this.slider({
				range: 'min',
				min: parseInt( $this.attr( 'min' ) ) || 0,
				max: parseInt( $this.attr( 'max' ) ) || 100,
				step: parseInt( $this.attr( 'step' ) ) || 10
			})
		})
		$wrappers.find( '.slider' ).slider( 'option', 'slide', function( ev, ui ){
			const val = ui.value
			if( $( this ).parent().find( '.display-val' ).hasClass( 'percentage' ) ){
				$( this ).closest( 'label' ).find( 'input' ).val( '0.' + val ).trigger( 'change' )
			} else {
				$( this ).closest( 'label' ).find( 'input' ).val( val ).trigger( 'change' )
			}
			$( this ).closest( 'label' ).find( '.display-val' ).text( val )
		})
		$wrappers.on( 'change', '.setting', function( ev ){
			const $this = $( this ),
				name = $this.attr( 'id' ).split( '-' )[0],
				val = $this.is( '[type=checkbox]' ) ? $this.prop( 'checked' ) : $this.val()

			settings.set( name, val )
		})
		$wrappers.on( 'keyup', '.setting', function( ev ){
			$( this ).change()
		})

		/*if( window.webkitNotifications ){
			if( window.webkitNotifications.checkPermission() != 0 ){
				$( '<a href="">Grant browser permission for Chrome/Safari notifications</a>' ).click( function( ev ){
					ev.preventDefault()
					window.webkitNotifications.requestPermission()
				})
					.prependTo( '#notifyPm-setting' )
			}
		}*/
		for( const key of Object.keys( this.settings ) ){
			watch(
				() => this.settings[key],
				( value, prevValue ) => {
					if( $( '#' + key + '-setting' )[0] ){
						$( '#' + key + '-setting' ).val( value )
						const $label = $( '#' + key + '-setting' ).closest( 'label' )
						if( $label[0] ){
							if( $label.find( '.display-val' ).hasClass( 'percentage' ) ){
								if( value > 1 ){
									value = value / 100
								}
								value = value * 100
							}
							$label.find( '.display-val' ).text( value )

							if( $label.find( 'input[type=checkbox]' )[0] ){
								if( value === true ){
									$label.find( 'input[type=checkbox]' ).prop( 'checked', true )
								} else {
									$label.find( 'input[type=checkbox]' ).prop( 'checked', false )
								}
							}
							const $slider = $label.find( '.slider' )
							if( $slider[0] ){
								$slider.slider( 'option', 'value', value )
							}
						}
					}
				}, {
					deep: true,
					immediate: true
				}
			)
		}
	}
}
</script>